import { List } from '@buffer-mono/popcorn'

type BulletPointsProps = {
  items: string[]
}

const BulletPoints = ({ items }: BulletPointsProps): JSX.Element => {
  return (
    <List>
      {items.map((text: string, index: number) => (
        <List.Item key={index}>{text}</List.Item>
      ))}
    </List>
  )
}

export default BulletPoints
